@if (loading()) {
  <div class="coi-skeleton">
    <p-skeleton height="2rem" width="55%" />
    <p-skeleton height="1rem" width="35%" />
    <p-skeleton height="22rem" />
  </div>
} @else if (notFound() || !data()) {
  <div class="coi-empty">
    <i class="pi pi-file-excel"></i>
    <p>No certificate found for that reference.</p>
  </div>
} @else if (data(); as d) {
  <div class="coi">
    <!-- ===== summary header ===== -->
    <div class="coi-head">
      <div class="coi-title">
        <h3>Certificate of Insurance</h3>
        @if (isIssued()) {
          <p-tag value="ISSUED" severity="success" />
        } @else {
          <p-tag value="PENDING ISSUE" severity="warn" />
        }
      </div>
      <div class="coi-meta">
        @if (d.policyNo) { <div class="coi-kv"><span>Policy / Certificate No</span><strong class="mono">{{ d.policyNo }}</strong></div> }
        @if (d.masterPolicyName) { <div class="coi-kv"><span>Insured</span><strong>{{ d.masterPolicyName }}</strong></div> }
        <div class="coi-kv"><span>Member</span><strong>{{ d.fullName || ('Member #' + d.memberId) }}@if (d.memberUniqueId) { <span class="mono"> ({{ d.memberUniqueId }})</span>}</strong></div>
        @if (d.coverageStartDate || d.policyEndDate) {
          <div class="coi-kv"><span>Period</span><strong>{{ (d.coverageStartDate || d.policyStartDate) | indDate }} – {{ d.policyEndDate | indDate }}</strong></div>
        }
      </div>
    </div>

    <!-- ===== certificate body ===== -->
    @if (isIssued()) {
      <div class="coi-frame-wrap">
        @if (htmlLoading()) {
          <div class="coi-loading"><i class="pi pi-spin pi-spinner"></i> Loading certificate…</div>
        } @else if (coiHtml()) {
          <iframe class="coi-frame" title="Certificate of Insurance" sandbox [srcdoc]="coiHtml()"></iframe>
        } @else {
          <div class="coi-loading muted">Certificate preview is unavailable. Use Print / Download to get the PDF.</div>
        }
      </div>
    } @else {
      <div class="coi-note">
        <i class="pi pi-info-circle"></i>
        The certificate will be available once the payment is completed and the policy is issued.
      </div>
    }

    <!-- ===== actions ===== -->
    <div class="coi-actions">
      <p-button label="Send to customer" icon="pi pi-send" [outlined]="true"
        [disabled]="!isIssued()" (onClick)="showSend.set(true)" />
      <p-button label="Print" icon="pi pi-print" [outlined]="true"
        [disabled]="!isIssued()" [loading]="printing()" (onClick)="print()" />
      @if (canWelcome()) {
      <p-button label="Welcome + COI" icon="pi pi-download"
        [disabled]="!isIssued() || downloading()" [loading]="downloadKind() === 'combined'" (onClick)="download()" />
      <p-button label="COI only" icon="pi pi-file" [outlined]="true"
        [disabled]="!isIssued() || downloading()" [loading]="downloadKind() === 'coi'" (onClick)="downloadCoiOnly()" />
      <p-button label="Welcome letter" icon="pi pi-envelope" [outlined]="true"
        [disabled]="!isIssued() || downloading()" [loading]="downloadKind() === 'welcome'" (onClick)="downloadWelcomeLetter()" />
      } @else {
      <p-button label="Download PDF" icon="pi pi-download"
        [disabled]="!isIssued() || downloading()" [loading]="downloadKind() === 'combined'" (onClick)="download()" />
      }
    </div>
  </div>

  <app-send-coi-dialog [(visible)]="showSend" [memberId]="d.memberId" />
}
